import { set_user } from 'store/actionTypes'

const userReducer = (state: boolean = false, action) => {
    switch (action.type) {
        case set_user:
            return action.payload.user;
        default:
            return state;
    }
}

export default userReducer;